import { Connection, PublicKey, Cluster, SystemProgram, Transaction } from "@solana/web3.js";
import type { CreateListingParams, SignMsgFn } from "./types";
import {
	PROGRAM_ID,
	getProtocolTreasury,
	getPythSolUsdFeed,
} from "./constants";
import { createInitListingInstruction } from "./generated/instructions/initListing";
import BN from "bn.js";


export const getDataSizeOfListing = (): number => {
	return (
		8 + // Account disscriminator
		1 + // version
		50 + // header
		1_000 + // Content (1 KB)
		32 + // Publisher
		32 + // Application
		8 + // createdAt
		1 + // expiringAt (Option)
		8 + // expiredAt
		1 + // active
		8 + // updatedAt
		200 + // assets (200 B)
		200 + // tags (200 B)
		1_000 // history (1 KB)
	);
};

/**
 * Create a InitListing transaction that will be signed by publisher
 *
 * @deprecated Use ListingClient.initListing() instead
 * 
 */
export const createInitListingTx = async (
	connection: Connection,
	cluster: Cluster,
	publisher: PublicKey,
	params: CreateListingParams,
) => {
	const listingSpace = getDataSizeOfListing();
	const lamports = await connection.getMinimumBalanceForRentExemption(
		listingSpace
	);

	// Instruction 1: Create Account instruction
	const createAccIx = SystemProgram.createAccount({
		fromPubkey: publisher,
		newAccountPubkey: params.listingAcc.publicKey,
		lamports,
		space: listingSpace,
		programId: PROGRAM_ID,
	});

	// Instruction 2: Initialize Listing instruction
	const initListingIx = createInitListingInstruction(
		{
			listing: params.listingAcc.publicKey,
			publisher: publisher,
			protocolTreasury: getProtocolTreasury(cluster),
			solUsdFeed: getPythSolUsdFeed(),
			application: params.application,
			systemProgram: SystemProgram.programId,
		},
		{
			payload: {
				header: params.header,
				content: params.content,
				application: params.application,
				expirationDays: params.expirationDays
					? new BN(params.expirationDays)
					: null,
				assets: params.assets,
				tags: params.tags,
			},
		}
	);

	const { blockhash, lastValidBlockHeight } =
		await connection.getLatestBlockhash();
	const tx = new Transaction();
	tx.recentBlockhash = blockhash;
	tx.lastValidBlockHeight = lastValidBlockHeight;
	tx.add(createAccIx, initListingIx);
	tx.feePayer = publisher;
	return tx;
};